/* eslint-disable no-unused-vars */
import React from 'react';
import { Flex, Text } from '@chakra-ui/react';

export interface TabStripItem {
  id: string;
  label: string;
  count?: number;
}

interface TabStripProps {
  items: TabStripItem[];
  activeId: string;
  onChange: (id: string) => void;
}

export const TabStrip = ({ items, activeId, onChange }: TabStripProps) => (
  <Flex
    align="stretch"
    flexWrap="wrap"
    bg="surface.frame"
    borderBottom="1px solid"
    borderColor="line.hairline"
  >
    {items.map((item) => {
      const isActive = item.id === activeId;
      return (
        <Flex
          as="button"
          type="button"
          key={item.id}
          h="40px"
          px="16px"
          gap="8px"
          align="center"
          cursor="pointer"
          mb="-1px"
          borderBottom="2px solid"
          borderX={isActive ? '1px solid' : 'none'}
          borderColor={isActive ? 'line.hairline' : 'transparent'}
          borderBottomColor={isActive ? 'content.strong' : 'transparent'}
          bg={isActive ? 'surface.base' : 'transparent'}
          color={isActive ? 'content.strong' : 'content.body'}
          fontWeight={isActive ? 500 : 400}
          _first={{ borderLeft: 'none' }}
          _hover={isActive ? {} : { bg: 'rgba(41, 41, 41, 0.02)' }}
          aria-pressed={isActive}
          onClick={() => onChange(item.id)}
        >
          <Text fontSize="13px" lineHeight="20px">
            {item.label}
          </Text>
          {item.count != null && (
            <Text
              fontFamily="mono"
              fontSize="12px"
              px="6px"
              py="1px"
              borderRadius="sm"
              bg={isActive ? 'surface.selected' : 'rgba(41, 41, 41, 0.04)'}
              color={isActive ? 'content.body' : 'content.subtle'}
            >
              {item.count}
            </Text>
          )}
        </Flex>
      );
    })}
  </Flex>
);
